/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-26 15:31:12
 * @LastEditors: linxi
 * @LastEditTime: 2022-12-27 17:19:22
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Modal, notification, Row, Upload } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import React, { ReactElement, useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { RootDispatch } from '../../app/store'
import { getPreCautionSubmitAsync } from './PreCautionSlice'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import {
  acceptImgTypes,
  AXIOS_IP,
  beforeUploadALL,
  customRequest,
} from '../filingManagement/fileUploadService'
import {selectTenantCityCode} from "../../app/applicationSlice";

interface rectifyAndReformModalProps {
  flag?:any
  ruleName?:string
  ids?: any
  visible: boolean
  onCancel: () => void
  onOk: () => void
}
export const RectifyAndReformModal = ({
  flag,
  ruleName,
  ids,
  visible,
  onCancel,
  onOk,
}: rectifyAndReformModalProps): ReactElement => {
  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const [fileList, setFileList] = useState<any[]>([])
  const tenantCityCode = useSelector(selectTenantCityCode)
  const MULTI_AXIOS_IP = window.location.origin +  `/supervise_proxy/${tenantCityCode == '320200' ? 'wuxi' : 'jiangsu'}/admin-api`
  // const MULTI_AXIOS_IP = 'https://his.test.hydhis.com' +  `/supervise_proxy/${tenantCityCode == '320200' ? 'wuxi' : 'jiangsu'}/admin-api`
  useEffect(() => {
    setFileList([])
  }, [visible])

  // 上传资料（参考自助备案：先调用 infra/file/uploadFile，接口返回 path）
  const handleCustomRequest = (options: any) => {
    customRequest(options, MULTI_AXIOS_IP, (data: any) => {
      setFileList((prev: any[]) => [
        ...prev,
        { fileName: data?.name, path: data?.path },
      ])
    })
  }

  const handleRemove = (index: number) => {
    setFileList(fileList.filter((_: any, i: number) => i !== index))
  }

  return (
    <>
      <Modal
        title='整改'
        width={600}
        okText='提交'
        visible={visible}
        confirmLoading={loading}
        onCancel={() => {
          onCancel()
          form.resetFields()
        }}
        onOk={() => {
          form.submit()
        }}
        destroyOnClose
        maskClosable={false}
        // bodyStyle={{ height: "250px" }}
      >
        <Form
          form={form}
          onFinish={(v) => {
            setLoading(true)
            const params = {
              ids: ids,
              selfExecuteContent: v?.selfExecuteContent,
              // 多个文件用三个@符号分割
              fileUrl: fileList.map((item) => item.path).join('@@@'),
            }
            dispatch(getPreCautionSubmitAsync(params))
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                onOk()
                form.resetFields()
                setLoading(false)
              })
              .catch(() => {
                onOk()
                form.resetFields()
                setLoading(false)
              })
          }}
        >
          <Form.Item
            name='selfExecuteContent'
            label='整改内容'
            rules={[{ required: true, message: '请选择整改内容' }]}
          >
            <div>
              <TextArea
                placeholder='如有整改请填写整改内容；如无需整改请填写无需整改理由。'
                style={{ height: 158 }}
              ></TextArea>

              {!flag && ruleName && ruleName.indexOf("无处方权开具处方") >= 0 && (
                <div>
                  <p>
                    如存在医生信息未及时更新的情况，请去人力资源平台更新医生信息：
                    <br />
                    <a
                      href='#'
                      onClick={() =>
                        window.open('https://apps.jsehealth.com:8000/jsrlzy/')
                      }
                    >
                      https://apps.jsehealth.com:8000/jsrlzy/
                    </a>
                  </p>
                </div>
              )}
            </div>
          </Form.Item>
          <Form.Item label='上传资料' name='' style={{ marginLeft: 12 }}>
            <Row align='middle'>
              <Upload
                customRequest={handleCustomRequest}
                beforeUpload={(file) => beforeUploadALL(file, fileList, 10)}
                showUploadList={false}
                maxCount={10}
                accept={`${acceptImgTypes},.pdf`}
              >
                <Button icon={<PlusOutlined />}>上传附件</Button>
              </Upload>
              <span style={{ padding: '0 10px 0 15px' }}>
                最多上传10个文件
              </span>
            </Row>
            {fileList?.length > 0 &&
              fileList.map((v: any, index: number) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: 10,
                  }}
                >
                  <span style={{ paddingRight: 10 }}>{v.fileName}</span>
                  <CloseOutlined
                    style={{ color: 'rgb(161 161 161)' }}
                    onClick={() => handleRemove(index)}
                  />
                </div>
              ))}
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
